import React,{useEffect, useState,useRef,useImperativeHandle} from 'react';

import TaskList from './Tasks/Task List';
import TaskCreation from './Tasks/Task Creation';
import TaskServiceController from '../../Controllers/TaskService';
import CustomToaster,{notify} from '../Common Components/Custom_Toaster';
import LoadingOverlay from '../Common Components/Loading_Overlay';

const Tasks = ({fromEvent, toolTipData}) => {
  console.log("in workflow tab and tooltipData ", toolTipData);
  const [createTask, setCreateTask] = useState(false);
  const [selectedTaskCategory,setSelectedtaskcategory] = useState({});
  const [selectedOption,setSelectedOption]  =useState([]);
 const [taskJsonData,setTaskJsonData] = useState(null);
 const [taskId,setTaskId]= useState(0);
 const [taskBody,setTaskBody] = useState({});
 const [editTasks,setEditTasks]  = useState(false);
 const taskCont = new TaskServiceController();


 useEffect(()=>{
if(fromEvent)handleClick();
 },[fromEvent])
  const handleClick = () => {
    setTaskBody({});
    setSelectedOption([]);
    setSelectedtaskcategory({});
    setTaskId(0);
    setEditTasks(false);
    setCreateTask(true);

  };
  const handleBackClick = () => {
    setTaskBody({});
    setSelectedOption([]);
    setSelectedtaskcategory({});
    setTaskId(0);
    setCreateTask(false);
    setEditTasks(false);

  };
const handleSelectChange = (selected,tskCtg) => {
  console.log("selected",selected);
  console.log(tskCtg);
        console.log(selected);
        if(tskCtg){
          setSelectedtaskcategory(selected);
        }
       
        setSelectedOption(selected);
      };
  useEffect(()=>{
    console.log("slected ctg",selectedTaskCategory);
  },[selectedTaskCategory]);

  const taskCreationRef = useRef(null);

  const handleOnSave = () => {
    console.log('entered saveJson method');
    if (taskCreationRef.current) {
      console.log('taskCreationRef.current');
        const taskJson = taskCreationRef.current.taskCreationJson(); // Call the export function
        setTaskJsonData(taskJson);

        if (taskJson) {
          document.getElementById('loadingOverlay').style.display = 'flex';
          // Now save the exported data
          // Perform your save operation here (e.g., send it to a server)
          console.log("Saving final task data:", taskJson);

            let taskSaveJson = taskJson;
            if (typeof taskSaveJson === "string") {
              taskSaveJson = JSON.parse(taskJson);
             console.log("obj:", taskSaveJson);
            }
        
console.log('task name is available');
const addUpdateTasks = async ()=>{
console.log(taskSaveJson);
console.log(taskSaveJson.taskCtgy.value);
console.log(taskSaveJson.taskCtgy.id);
const requestBody={
"id": taskId,
  "taskName": taskSaveJson.taskName,
  "clientId": 1,
  "taskCategoryId": taskSaveJson.taskCtgy.id,
  "taskCriteria":taskSaveJson.taskParameter,
  "createdDate": taskBody.createdDate,
  "createdBy": taskBody.createdBy,
  "modifiedDate": taskBody.modifiedDate,
  "modifiedBy": taskBody.modifiedBy,
  "isActive": taskBody.isActive,
  "isPublished": taskBody.isPublished
}
console.log("API request body",requestBody);
   const body = await taskCont.addUpdateTasks(requestBody);
            console.log(body);
            document.getElementById('loadingOverlay').style.display = 'none';
            if (body["Success"]) {
              await notify(
                `${requestBody.taskName} has been successfully saved`,
                true
              )
                handleBackClick();
    
            
            } else {
              body["Response"] === `${requestBody.taskName} already exists...`
                ? await notify(`"${requestBody.taskName}" already exists. Save with another name...`, false)
                : await notify(
                    "There was an error while saving the template. Please try again later...",
                    false
                  );
            }
}
addUpdateTasks();
        // }

        } else {
          console.log("No data to save");
        }
    }
  };
 

  const editTaskData=( id,requestBody)=>{
    setTaskId(id);
    setTaskBody(requestBody);
    setEditTasks(true);
    setCreateTask(true);
  }
  
  return !createTask ? (
   <>
   <TaskList onHandleClick ={handleClick} editTaskData={editTaskData} toolTipData={toolTipData}/>
   </>
  ) : (
    <>
    <TaskCreation onBackClick={handleBackClick} handleSelectChange={handleSelectChange} taskCategory={selectedTaskCategory} selectedOption={selectedOption} ref={taskCreationRef} onHandleSave={handleOnSave} taskId={taskId} taskBody={taskBody} onEdit={editTasks}/>
    <CustomToaster />
    <LoadingOverlay/>
    </>
  )
}

export default Tasks